import { checkStatus } from 'common/utils/helpers';

export const patchdata = (url, data) => {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
  };

  let options = {
    method: 'PATCH',
    body: JSON.stringify(data),
    headers: headers
  };
  return fetch(url, options)
    .then((response) => checkStatus(response))
    .then((response) => {
      return response;
    });
};
